<template>
  <div>
    <vue-headful :title="title" />
    <div class="mx-4 my-2">
      <div class="card">
        <div class="card-header">
          <div class="card-header-title">JSON</div>
          <button class="card-header-icon" aria-label="more options">
            <span class="icon" @click="jsonToggledOn = !jsonToggledOn">
              <font-awesome-icon :icon="['far', 'angle-down']" v-if="jsonToggledOn" />
              <font-awesome-icon :icon="['far', 'angle-up']" v-if="!jsonToggledOn" />
            </span>
          </button>
        </div>
        <div v-if="terminal && jsonToggledOn" class="card-content p-0">
          <pre v-html="prettyPrintJson.toHtml(terminal, { indent: 2 })"></pre>
        </div>
      </div>
      <div class="card mt-4" v-if="$hasRole('Super User')">
        <div class="card-header">
          <div class="card-header-title">Danger Zone</div>
        </div>
        <div class="card-content">
          <b-message type="is-light is-danger" :closable="false" class="mt-4">
            <div class="columns">
              <div class="column is-four-fifths">
                <h6><strong>Delete Terminal</strong></h6>
                <p>You can delete the terminal by clicking the big, red delete button. This will permanently (read: it's gone forever, really) delete the terminal from OSS database.</p>
              </div>
              <div class="column is-one-fifth has-text-right">
                <button class="button is-danger" @click="deleteTerminal">Delete Terminal</button>
              </div>
            </div>
          </b-message>
        </div>
      </div>  
    </div>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { prettyPrintJson } from 'pretty-print-json';
import { useTerminalsStore } from '../terminals-store';

const store = useTerminalsStore();
const app = getCurrentInstance();
const router = useRouter();
const terminal = computed(() => store.state.terminal);
const title = computed(() => `${terminal.value?.name} / JSON`);
const jsonToggledOn = ref(true);

const deleteTerminal = async () => {
  app.proxy.$buefy.dialog.confirm({
    title: 'Delete Terminal',
    message: `Are you sure you want to delete terminal <strong>${terminal.value.name}</strong>? This action cannot be undone.`,
    cancelText: 'Cancel',
    confirmText: 'Delete Forever',
    type: 'is-danger',
    onConfirm: async () => {
      const res = await store.dispatch('deleteTerminal');
      if (res) {
        router.push({ path: '/terminals' });
      }
    }
  });
}
</script>
<style lang="scss">
@import '../../../../node_modules/pretty-print-json/dist/css/pretty-print-json.prefers.min.css';
</style>
